// export const IMG_URL = "http://127.0.0.1:1515";

// export const IMG_URL = "https://elementsnode.profcyma.org:1709";

// export const IMG_URL = "https://node.nutricos.in";

export const IMG_URL = "https://elementsstudionode.profcymadev.com:1709";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};


export const formatDateAndTime = (date) => {
  if (!date) return "";

  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) return "";

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
